import { createContext, useContext, type ReactNode } from 'react';
import { useCatalogImageResolveJobInbox } from '../hooks/useCatalogImageResolveJobInbox';

type CatalogImageResolveInboxContextValue = ReturnType<typeof useCatalogImageResolveJobInbox>;

const Ctx = createContext<CatalogImageResolveInboxContextValue | null>(null);

export function CatalogImageResolveInboxProvider({ children }: { children: ReactNode }) {
  const value = useCatalogImageResolveJobInbox();
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export function useCatalogImageResolveInboxContextOptional(): CatalogImageResolveInboxContextValue | null {
  return useContext(Ctx);
}
